const strings = {
  $GH_TOKEN: 'GH_TOKEN',
  $GH_REFRESH_TOKEN: 'GH_REFRESH_TOKEN',
};

export default strings;
